export default __webpack_public_path__ + "static/media/it-77.03a51de0.svg";